export const newsDetail = {
  showListButton: 'Show List',
  prev: 'PREV',
  next: 'NEXT',
  toastMessage: 'Link Copied',
}
